import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import AppUtils from '../../control/apputlis';



class IntegralRule extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'IntegralRule');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    render() {
        const { classes } = this.props;
        let { nav } = this.props.match.params;

        return (
            <MBack title='积分规则' backgroundColor="#FFF" hideNav={nav} >
                <Grid container direction='row' alignItems='center' className={classes.myInfo}>
                    <Typography style={{ fontSize: 15, color: '#0D0D0D',fontWeight:'bold' }}>一.如何获得积分</Typography>
                    <Grid style={{ fontSize: 13, color: '#919191', marginTop: 10 }}>
                        <Typography style={{ marginTop: 4, fontSize: 13 }}>1：每日签到 <span style={{ color: '#FF0000' }}>+1</span> 积分 <span style={{ color: '#FF0000' }}>（连续签到7天额外获得10积分）</span>  </Typography>
                        <Typography style={{ marginTop: 4, fontSize: 13 }}>2：直播公屏互动 <span style={{ color: '#FF0000' }}>+1</span> 积分</Typography>
                        <Typography style={{ marginTop: 4, fontSize: 13 }}>3：每日观看比赛时常10分钟 <span style={{ color: '#FF0000' }}>+1</span>积分  </Typography>
                        <Typography style={{ marginTop: 4, fontSize: 13 }}>4：邀请新用户分享app  <span style={{ color: '#FF0000' }}>+5</span> 积分（每天3次） </Typography>
                    </Grid>
                    <Typography style={{ fontSize: 15, color: '#0D0D0D', marginTop: 24 ,fontWeight:'bold'}}>二.关于积分商城</Typography>
                    <Grid container direction='row'>
                        <Typography style={{ fontSize: 13, color: '#919191', marginTop: 10, lineHeight: 1.8 }}>
                            什么是积分商城？<br />
                            1：积分商城是F7体育平台为广大用户提供的免费福利，只要您
                            能成为我们的用户即可获取积分。积分可以用来兑换超值礼品，
                            也可以兑换平台福利。<br />
                            2：商城的商品只能用积分兑换,不可以用现金等其他方式获取。<br />
                            3：积分兑换奖品需提供正确的地址、电话及收件人，F7体育将
                            负责全国包邮。<br />
                            4：平台有权随时调整积分商城规则并进行公告，如遇活动漏洞
                            或者大规模作弊行为，包括不限于按照非正常流程获取权益，
                            F7体育有权在相关规定允许范围内直接下线活动并保留回收
                            权益，保留变更本规则与条款的权力。<br />
                        </Typography>
                    </Grid>
                </Grid>
            </MBack >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    myInfo: {
        paddingTop: 36,
        paddingBottom: 24,
        paddingRight: 16,
        paddingLeft: 16
    },
}))(IntegralRule));